import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LocalizedRouterLinkPipe } from '@core/i18n/localized-router-link.pipe';
import { TranslocoPipe } from '@jsverse/transloco';
import { FOOTER_SECTIONS } from '@core/navigation/nav.config';
import { InfogovLogoComponent } from '@shared/components/infogov-logo/infogov-logo.component';

@Component({
  selector: 'app-site-footer',
  standalone: true,
  imports: [RouterLink, TranslocoPipe, InfogovLogoComponent, LocalizedRouterLinkPipe],
  templateUrl: './site-footer.component.html',
})
export class SiteFooterComponent {
  protected readonly sections = FOOTER_SECTIONS;
}
